import { ProductProvider } from 'context/productContext/productContext'
import { ProjectPageProvider } from 'context/projectContext/projectContext'
import { SettingsPageProvider } from 'context/settingsPageContext/settingsPageContext'
import { ViewTaskPageProvider } from 'context/viewTaskPageContext/viewTaskPageContext'
import NotAuthorisedPage from 'pages/NotAuthorisedPage/NotAuthorisedPage'
import NotFound404Page from 'pages/NotFound404Page/NotFound404Page'
import ProjectManagerPage from 'pages/ProjectManagerPage/ProjectManagerPage'
import ImportedLogsView from 'pages/ProjectView/ImportedLogsView/ImportedLogsView'
import ProjectViewV2 from 'pages/ProjectView/ProjectViewV2'
import SingleProductView from 'pages/ProjectView/SingleProductView/SingleProductView'
import SingleVariantView from 'pages/ProjectView/SingleVariantView/SingleVariantView'
import { CreateBrand, ClientView, BrandView } from 'pages/Settings/ClientsAndBrands'
import CreateRegionView from 'pages/Settings/Regions/CreateRegionView'
import RegionView from 'pages/Settings/Regions/RegionView'
import SettingsPage from 'pages/Settings/SettingsPage'
import TaskManagerPage from 'pages/TaskManagerPage/TaskManagerPage'
import ViewTaskPage from 'pages/ViewTask/ViewTaskPage'
import { useMemo } from 'react'
import { Route, Routes } from 'react-router-dom'
import { withTitle } from './withTitleHOC'

export default function AppRouter() {
  const ProjectsPageWithTitle = withTitle(ProjectManagerPage, 'Projects | PDP Generator')
  const ProjectWorkspacePageWithTitle = withTitle(ProjectViewV2, 'Project Workspace | PDP Generator')
  const ProjectWorkspaceLogsPageWithTitle = withTitle(ImportedLogsView, 'Project Logs | PDP Generator')
  const ProjectWorkspaceProductPageWithTitle = withTitle(SingleProductView, 'Product | PDP Generator')
  const ProjectWorkspaceProductVariantPageWithTitle = withTitle(SingleVariantView, 'Product Variant | PDP Generator')
  const TasksPageWithTitle = withTitle(TaskManagerPage, 'Tasks | PDP Generator')
  const TasksPageSlugWithTitle = withTitle(ViewTaskPage, 'Task | PDP Generator')
  const SettingsPageWithTitle = withTitle(SettingsPage, 'Settings | PDP Generator')
  const ClientsSettingsPageWithTitle = withTitle(SettingsPage, 'Clients | Settings | PDP Generator')
  const RegionsSettingsPageWithTitle = withTitle(SettingsPage, 'Regions | Settings | PDP Generator')
  const ClientConfigPageWithTitle = withTitle(ClientView, 'Client Config | PDP Generator')
  const BrandConfigPageWithTitle = withTitle(BrandView, 'Brand Config | PDP Generator')
  const RegionConfigPageWithTitle = withTitle(RegionView, 'Region Config | PDP Generator')
  const CreateBrandPageWithTitle = withTitle(CreateBrand, 'Create Brand | PDP Generator')
  const CreateRegionPageWithTitle = withTitle(CreateRegionView, 'Create Region | PDP Generator')

  const NotAuthorisedPageWithTitle = withTitle(NotAuthorisedPage, 'Not Authorised | PDP Generator')
  const NotFound404PageWithTitle = withTitle(NotFound404Page, 'Not Found | PDP Generator')

  const createRoutes = useMemo(() => {
    return (
      <SettingsPageProvider>
        <Routes>
          <Route path="/:client_id/brand" element={<CreateBrandPageWithTitle />} />
          <Route path="/region" element={<CreateRegionPageWithTitle />} />
          <Route path="*" element={<NotFound404PageWithTitle />} />
        </Routes>
      </SettingsPageProvider>
    )
  }, [])

  const settingsRoutes = useMemo(() => {
    return (
      <SettingsPageProvider>
        <Routes>
          <Route path="/" element={<SettingsPageWithTitle />} />
          <Route path="/clients" element={<ClientsSettingsPageWithTitle />} />
          <Route path="/client/:client_id" element={<ClientConfigPageWithTitle />} />
          <Route path="/client/:client_id/brand/:brand_id" element={<BrandConfigPageWithTitle />} />
          <Route path="/regions" element={<RegionsSettingsPageWithTitle />} />
          <Route path="/region/:region_id" element={<RegionConfigPageWithTitle />} />
          <Route path="*" element={<NotFound404PageWithTitle />} />
        </Routes>
      </SettingsPageProvider>
    )
  }, [])

  const projectRoutes = useMemo(() => {
    return (
      <ProjectPageProvider>
        <Routes>
          <Route path="/:project_id" element={<ProjectWorkspacePageWithTitle />} />
          <Route path="/:project_id/logs" element={<ProjectWorkspaceLogsPageWithTitle />} />
          <Route
            path="/:project_id/product/:product_id"
            element={
              <ProductProvider>
                <ProjectWorkspaceProductPageWithTitle />
              </ProductProvider>
            }
          />
          <Route
            path="/:project_id/product/:product_id/variant/:variant_id"
            element={
              <ProductProvider>
                <ProjectWorkspaceProductVariantPageWithTitle />
              </ProductProvider>
            }
          />
          <Route path="*" element={<NotFound404PageWithTitle />} />
        </Routes>
      </ProjectPageProvider>
    )
  }, [])

  return (
    <Routes>
      <Route path="/" element={<ProjectsPageWithTitle />} />
      <Route path="/projects" element={<ProjectsPageWithTitle />} />
      <Route path="/project/*" element={projectRoutes} />
      <Route path="/tasks" element={<TasksPageWithTitle />} />
      <Route path="/create/*" element={createRoutes} />
      <Route path="/settings/*" element={settingsRoutes} />

      <Route
        path="/task/:job_id"
        element={
          <ViewTaskPageProvider>
            <TasksPageSlugWithTitle />
          </ViewTaskPageProvider>
        }
      />

      <Route path="/not-authorised" element={<NotAuthorisedPageWithTitle />} />

      <Route path="*" element={<NotFound404PageWithTitle />} />
    </Routes>
  )
}
